import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    messages: {},
    messagesOrder: [],
    contragent_id: null,
    contragent_name: null,
    // accounts: [],
    accounts: {},
    apps: {},
    app_com_params: {},
    balances: {},
    requests: [],
    charges: [],
    payments: [],
    hide_controls: false,
    show_navbar: true,
    current_receipt: null,
    document_list: [],
    current_document: null,
    current_document_content: null,
    current_document_items: null,
    balance_charges: [],
    phone_calls: [],
    internet_traffic: [],
    current_account: null,
    connection_name: null,
    local_control: false,
    signin_code: false,
    signin_timeout: 60,
    signin_error: null,
    login_error: null,
    password_changed: false,
    password_changed_error: null,
    tar_plan_change_list: [],
    app_block_tarif_list: [],
    control_contragents: [],
    control_users_list: [],
    control_client_list: [],
    control_new_users: [],
    socket: {
      isConnected: false,
      message: '',
      reconnectError: false,
      connection: null
    },
    token: localStorage.getItem('user-token') || null,
    topics: [],
    username: null
  },
  getters: {
    showControl: state => {return !!state.local_control},
    isLoggedIn: state => {return !!state.token},
    currentAccount: function (state){
      if (!state.current_account){
        if (state.accounts.length > 0) {
          state.current_account = state.accounts[0]['account_id']
        }
      }
      return state.current_account
    },
    listAccounts: state => state.accounts,
    traffic: state => {return state.internet_traffic ?? []},
    calls: state => {return state.phone_calls ?? []}

  },
  mutations: {
    set_local_control(state, local_control){
      state.local_control = local_control;
    },
    auth_user(state, token){
      // console.log('AUTJ USER', token)
      state.token = token;
      state.login_error = null;
      if (token !== undefined) {
        localStorage.setItem('user-token', token)
      } else {localStorage.removeItem('user-token')}
    },
    login_error(state, error_msg){
      state.login_error = error_msg;
    },
    set_topics(state, topics){
      state.topics = topics;
    },
    set_username(state, username){
      state.username = username;
    },
    set_connection_name(state, name){
      state.connection_name = name;
    },
    set_contragent(state, contragent){
      contragent = contragent.data
      // console.log(partial)
      state.contragent_id = contragent['contragent_id'];
      state.contragent_name = contragent['name'];
    },
    set_current_account(state, account_id){
      state.current_account = account_id;
    },
    set_accounts(state, accounts){
      // let partial = accounts.partial
      // console.log('set_accounts')
      // console.log(accounts)
      accounts = accounts.data
      // accounts.forEach(element => state.accounts[element['account_id']] = element)
      accounts.forEach(element => Vue.set(state.accounts, element['account_id'], element))
    },
    set_account_apps(state, apps){
      apps = apps.data
      apps.forEach((element) => {
        let account_id = element['account_id'];
        let app_id = element['app_id'];
        // state.accounts[account_id].apps[app_id] = element})
        Vue.set(state.accounts[account_id].apps , app_id, element)})
    },
    set_app_service(state, services){
      // console.log('set_app_service')
      // console.log('services', services)
      if (services.data){
        services = services.data
        services.forEach((element) => {
          let account_id = element['account_id'];
          let app_id = element['app_id'];
          let acp_id = element['acp_id'];
          // state.accounts[account_id].apps[app_id].services[acp_id] = element})
          Vue.set(state.accounts[account_id].apps[app_id].services, acp_id, element)})
      }
    },
    set_balances(state, balances){
      let partial = balances.partial
      balances = balances.data
      let account_id = balances[0]['account_id'];
      let account_balance = state.balances[account_id] ?? []
      if (partial) {
        balances.forEach(balance => account_balance.push(balance))
      }
      else {account_balance = balances;}
      state.balances[account_id] = balances
    },
    set_charges(state, charges){
      charges = charges.data
      state.charges = charges
    },
    set_requests(state, requests){
      let partial = requests.partial
      requests = requests.data
      if (partial) {
        requests.forEach(request => state.requests.push(request))
      }
      else {state.requests = requests;}
    },
    signin_success(state){
      state.signin_code = true
      state.signin_timeout = 60
    },
    signin_error(state, error_msg){
      // console.log('signin_error', error_msg)
      state.signin_error = error_msg
    },
    signin_confirm_success(){
      // console.log('signin_confirm_success')
      // console.log(state)
    },
    signin_confirm_error(state, error_msg){
      console.log('signin_confirm_error', error_msg)
    },
    set_payments(state, payments){
      state.payments = payments.data
    },
    set_internet_traffic(state, internet_traffic){
      state.internet_traffic = internet_traffic.data
    },
    set_phone_calls(state, calls){
      let partial = calls.partial
      if (partial){
        state.phone_calls.push(calls.data)
      } else {
      state.phone_calls = calls.data}
    },
    set_current_receipt(state, data){
      if (data.data !== undefined){
        let partial = data.partial
        if (partial){
          state.current_receipt = data.data[0]
        } else {
        state.current_receipt = data.data[0]}
      }
    },
    clear_receipt(state){
      state.current_receipt = null
    },
    set_current_document(state, data){
      // console.log('set_current_document_data', data)
      if (data.data !== undefined) {
        // console.log('set_current_document_data_data', data.data)
        // console.log('set_current_document_data_data_0', data.data[0])
        let partial = data.partial
        if (partial) {
          state.current_document = data.data[0]
          state.topics = [data.data[0].region]
        } else {
          state.current_document = data.data[0]
          state.topics = [data.data[0].region]
        }
        // console.log('set_current_document', state.current_document)
      }
    },
    clear_current_document(state){
      // console.log('clear_current_document')
      state.current_document = null
    },
    set_current_document_content(state, data){
      if (data.data !== undefined) {
        let partial = data.partial
        if (partial) {
          state.current_document_content = data.data[0]
          // state.current_document_content.push(data.data)
        } else {
          state.current_document_content = data.data[0]
        }
      }
    },
    clear_current_document_content(state){
      state.current_document_content = null
    },
    set_current_document_items(state, data){
      // console.log('set_current_document_items')
      // console.log(data)
      if (data.data !== undefined) {
        let partial = data.partial
        if (partial) {
          state.current_document_items.push(data.data)
        } else {
          state.current_document_items = data.data
        }
      }
    },
    clear_current_document_items(state){
      state.current_document_items = null
    },
    set_document_list(state, data){
      if (data.data !== undefined){
        let partial = data.partial
        if (partial){
          state.document_list.push(data.data)
        } else {
        state.document_list = data.data}
      }
    },
    clear_document_list(state){
      state.document_list = []
    },
    set_app_tar_plan_change_list(state, tar_plans){
      let partial = tar_plans.partial
      if (partial){
        state.tar_plan_change_list.push(tar_plans.data)
      } else {
      state.tar_plan_change_list = tar_plans.data}
    },
    clear_app_tar_plan_change_list(state){
      state.tar_plan_change_list = []
    },
    set_app_block_tarif_list(state, block_tarif){
      let partial = block_tarif.partial
      if (partial){
        state.app_block_tarif_list.push(block_tarif.data)
      } else {
      state.app_block_tarif_list = block_tarif.data}
    },
    set_control_contragent_list(state, contragents){
      let partial = contragents.partial
      state.control_contragents.push(contragents.data)
      if (partial){
        state.control_contragents.push(contragents.data)
      } else {
      state.control_contragents = contragents.data}
    },
    clear_control_contragent_list(state){
      state.set_control_contragent_list = []
    },
    set_control_users_list(state, users){
      let partial = users.partial
      if (partial){
        state.control_users_list.push(users.data)
      } else {
      state.control_users_list = users.data}
    },
    set_control_client_list(state, clients){
      let partial = clients.partial
      if (partial){
        state.control_client_list.push(clients.data)
      } else {
      state.control_client_list = clients.data}
    },
    set_control_new_users(state, new_users){
      let partial = new_users.partial
      if (partial){
        state.control_new_users.push(new_users.data)
      } else {
      state.control_new_users = new_users.data}
    },
    clear_app_block_tarif_list(state){
      state.app_block_tarif_list = []
    },
    set_password_changed(state, value){
      state.password_changed = value
    },
    set_password_changed_error(state, value){
      state.password_changed_error = value
    },
    show_navbar(state, value){
      state.show_navbar = value;
    },
    hide_controls(state, value){
      state.hide_controls = value;
    },
    log_out(state){
      state.token = null
      localStorage.removeItem('user-token')
    },
    socket_connected(state, connected){
      state.socket.isConnected = connected
    }
  },
  actions: {
    logOut(context){
      context.commit('log_out')
      router.push('/login')
    },
    sendMessage(context, payload){
      // console.log('sendmessage', payload)
      // console.log(Vue.prototype.$socketClient)
      Vue.prototype.$socketClient.sendObj(payload)
      // context.state.socket.connection.send(JSON.stringify(payload))
    },
    socketConnected(context, connected){
      context.commit('socket_connected', connected)
    },
    localControl(context, local_control){
      context.commit('set_local_control', local_control)
    },
    authUser(context, token){
      // console.log('authUser')
      context.commit('auth_user', token)
      // console.log('authUser')
      // console.log(Vue.prototype.$router)
      // router.replace('/profile')
      // console.log('show_invoice',context.state.show_invoice)
      if (context.state.show_invoice === false){
        router.push('/profile')
      }
    },
    showInvoice(context){
      context.commit('show_invoice', true)
    },
    hideInvoice(context){
      context.commit('show_invoice', false)
    },
    showNavbar(context){
      context.commit('show_navbar', true)
    },
    hideNavbar(context){
      context.commit('show_navbar', false)
    },
    setTopics(context, topics){
      context.commit('set_topics', topics)
    },
    setUsername(context, username){
      context.commit('set_username', username)
    },
    authRequest(context, payload){
      context.dispatch('sendMessage', {'event':'auth/request', 'data': payload})
    },
    refreshUser(context, payload){
      context.dispatch('sendMessage', {'event': 'control/request', "data": {'method': 'refresh_user', param: payload}})
    },
    resetUser(context, payload){
      context.dispatch('sendMessage', {'event': 'control/request', "data": {'method': 'reset_user', param: payload}})
    },
    deleteUser(context, payload){
      context.dispatch('sendMessage', {'event': 'control/request', "data": {'method': 'delete_user', param: payload}})
    },
    signIn(context, payload){
      context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'check_pin', 'param': payload}})
    },
    resendToken(context, payload){
      context.dispatch('sendMessage', {'event': 'control/request', "data": {'method': 'resend_token', param: payload}})
    },
    deleteToken(context, payload){
      context.dispatch('sendMessage', {'event': 'control/request', "data": {'method': 'delete_token', param: payload}})
    },
    signInConfirm(context, payload){
      context.dispatch('sendMessage', {'event':'signinconfirm/request', 'data': payload})
    },
    signinResult(context, msg){
      if (msg.data[0].success){
        context.commit('signin_success')
      }
      else {context.commit('signin_error', msg.data[0]['message'])}
    },
    signinResultConfirm(context, msg){
      if (msg.success){
        context.commit('signin_confirm_success')
      }
      else {context.commit('signin_confirm_error', msg['message'])}
    },
    passChange(context, payload){
      context.dispatch('sendMessage', {'event':'passchange/request', 'data': payload})
    },
    passRestore(context, payload){
      context.dispatch('sendMessage', {'event':'passrestore/request', 'data': payload})
    },
    setCurrentAccount(context, account_id){
      context.commit('set_current_account', account_id)
    },
    setContragent(context, contragent){
      context.commit('set_contragent', contragent)
    },
    setAccounts(context, accounts){
      context.commit('set_accounts', accounts)
      // context.commit('set_accs', accounts)
      // console.log(accounts)
      accounts = accounts.data
      accounts.forEach((account) => {
        context.dispatch('getAccountApps', account['account_id'])
        context.dispatch('getBalances', account['account_id'])
      })
    },
    setAccountApps(context, apps){
      context.commit('set_account_apps', apps)
      // console.log('setAccountApps')
      apps = apps.data
      apps.forEach((app) => {
        // console.log({"app_id": app['app_id'], "account_id": app['account_id']})
        context.dispatch('getAppService', {"app_id": app['app_id'], "account_id": app['account_id']})
      })
    },
    setAppService(context, services){
      context.commit('set_app_service', services)
      // if (services==services){services=1}
    },
    setBalances(context, balances){
      context.commit('set_balances', balances)
    },
    setRequests(context, requests){
      context.commit('set_requests', requests)
    },
    setCharges(context, charges){
      context.commit('set_charges', charges)
    },
    setPayments(context, payments) {
      context.commit('set_payments', payments)
    },
    setPhoneCalls(context, payments) {
      context.commit('set_phone_calls', payments)
    },
    setCurrentReceipt(context, data) {
      context.commit('set_current_receipt', data)
    },
    setDocumentList(context, data) {
      context.commit('set_document_list', data)
    },
    setCurrentDocument(context, data) {
      context.commit('set_current_document', data)
      if (context.state.current_document) {
        context.dispatch('getCurrentDocumentContent', {'document_id': context.state.current_document.id})
        context.dispatch('getCurrentDocumentItems', {'document_id': context.state.current_document.id})
      }
    },
    setCurrentDocumentContent(context, data) {
      context.commit('set_current_document_content', data)
    },
    setCurrentDocumentItems(context, data) {
      context.commit('set_current_document_items', data)
    },
    setAppTarPlanChangeList(context, payments) {
      context.commit('set_app_tar_plan_change_list', payments)
    },
    setAppBlockTarifList(context, payments) {
      context.commit('set_app_block_tarif_list', payments)
    },
    setControlContragent(context, payments) {
      context.commit('set_control_users_list', payments)
    },
    setControlClients(context, clients) {
      context.commit('set_control_client_list', clients)
    },
    setControlNewUsers(context, clients) {
      context.commit('set_control_new_users', clients)
    },
    setControlUsers(context, payments) {
      context.commit('set_control_users_list', payments)
    },
    setInternetTraffic(context, payments) {
      context.commit('set_internet_traffic', payments)
    },
    setPassChanged(context, value){
      context.commit('set_password_changed', value)
    },
    setPassChangedError(context, value){
      context.commit('set_password_changed_error', value)
    },
    changeAppTarPlan(context, param) {
       context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'app_tar_plan_change', 'param': param}, 'topic': context.state.topics})
    },
    changeInetPass(context, param) {
       context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'app_pass_change', 'param': param}, 'topic': context.state.topics})
    },
    getContragent(context){
      // console.log('get_contragent')
      context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_contragent'}, 'topic': context.state.topics})
    },
    getAccounts(context){
      // console.log('get accounst', context)
      context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_accounts'}, 'topic': context.state.topics})
    },
    getAccountApps(context, account_id){
      context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_account_apps', 'param': account_id}, 'topic': context.state.topics})
    },
    getAppService(context, param){
      context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_app_com_params', 'param': param}, 'topic': context.state.topics})
    },
    getBalances(context, param){
      context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_balances', 'param': param}, 'topic': context.state.topics})
    },
    getPayments(context, param){
      context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_payments', 'param': param}, 'topic': context.state.topics})
    },
    getCharges(context, param){
      context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_charges', 'param': param}, 'topic': context.state.topics})
    },
    getRequests(context){
      context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_requests'}, 'topic': context.state.topics})
    },
    getPhoneCalls(context, param){
      context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_phone_calls', 'param': param}, 'topic': context.state.topics})
    },
    getInternetTraffic(context, param){
      context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_internet_traffic', 'param': param}, 'topic': context.state.topics})
    },
    getAppTarPlanChangeList(context, param){
      context.commit('clear_app_tar_plan_change_list')
      context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_app_tar_plan_change_list', 'param': param}, 'topic': context.state.topics})
    },
    getAppBlockTarifList(context, param){
      context.commit('clear_app_block_tarif_list')
      context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_app_block_tarif_list', 'param': param}, 'topic': context.state.topics})
    },
    blockApp(context, param){
      context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'app_block', 'param': param}, 'topic': context.state.topics})
    },
    unblockApp(context, param){
      context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'app_unblock', 'param': param}, 'topic': context.state.topics})
    },
    getAppInetTraffic(context, param){
      let topics = context.state.topics.map(function(element){return element+'_inet';});
      // context.commit('clear_app_traffic_list')
      context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_sessions', 'param': param}, 'topic': topics})
    },
    getAppCalls(context, param){
      // context.commit('clear_app_calls_list')
      context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_phone_calls', 'param': param}, 'topic': context.state.topics})
    },
    addAccount(context, param){
      // context.commit('clear_app_calls_list')
      context.dispatch('sendMessage', {'event': 'addaccount/request', data: {'method': 'add_account', 'param': param}, 'topic': context.state.topics})
    },
    controlContragentListClear(context){
      context.commit('clear_control_contragent_list')
    },
    controlContragentList(context, param){
      // console.log(context.state.topics)
      context.dispatch('controlContragentListClear')
      context.dispatch('sendMessage', {'event': 'control/request', data: {'method': 'cabinet_users', 'param': param}, 'topic': ['almaty', 'astana']})
    },
    getControlClientList(context){
      // console.log("getControlClientList")
      context.dispatch('sendMessage', {'event': 'control/request', data: {'method': 'server_client'}, 'topic': context.state.topics})
    },
    getControlNewUsers(context){
      context.dispatch('sendMessage', {'event': 'control/request', data: {'method': 'new_users'}, 'topic': context.state.topics})
    },
    getCurrentReceipt(context, param){
      param.document_type_code = 'RECEIPT'
      context.commit('clear_receipt')
      context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_document', 'param': param}, 'topic': context.state.topics})
    },
    clearCurrentReceipt(context){
      context.commit('clear_receipt')
    },
    getCurrentReceiptByAccountIin(context, param){
      context.commit('clear_receipt')
      context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_current_receipt', 'param': param}, 'topic': ['almaty', 'astana']})
    },
    getDocumentList(context, param){
      context.commit('clear_document_list')
      context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'list_documents', 'param': param}, 'topic': ['almaty', 'astana']})
    },
    getDocument(context, param){
      context.dispatch('clearCurrentDocument')
      if (context.state.topics !== undefined){
        if (context.state.topics.length > 0){
          context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_document', 'param': param}, 'topic': context.state.topics})
        } else {
          context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_document', 'param': param}, 'topic': ['almaty', 'astana']})
        }
      } else {
        context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_document', 'param': param}, 'topic': ['almaty', 'astana']})
      }
    },
    clearCurrentDocument(context){
      context.commit('clear_current_document')
    },
    getCurrentDocumentContent(context, param){
      context.commit('clear_current_document_content')
      if (context.state.topics.length > 0){
        context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_document_content', 'param': param}, 'topic': context.state.topics})
      } else {
        context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_document_content', 'param': param}, 'topic': ['almaty', 'astana']})
      }
    },
    getCurrentDocumentItems(context, param){
      context.commit('clear_current_document_items')
      if (context.state.topics.length > 0){
        context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_document_items', 'param': param}, 'topic': context.state.topics})
      } else {
        context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_document_items', 'param': param}, 'topic': ['almaty', 'astana']})
      }
    },
    clearCurrentDocumentContent(context){
      context.commit('clear_current_document_content')
    },
    setDocumentAcceptState(context, param){
      context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'accept_document', 'param': param}, 'topic': ['almaty', 'astana']})
    },
    setSendReceiptToEmail(context, param){
      context.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'set_receipt_to_email', 'param': param}, 'topic': context.state.topics})
    },
    testAction(context, item){
      console.log('testAction')
      console.log(item)
    },

    onMessage(context, msg){
      if (msg['event'] === undefined){
        console.log('Unknown server method')
      }
      else {
        context.dispatch(msg['event'].replace('/', '_'), msg)
      }
    },

    greet_request(context, msg){
      // console.log('greet_request')
      if(msg){msg = null}
      if (context.getters.isLoggedIn) {
        context.dispatch('sendMessage', {'event':'auth/request', 'data': {'token': context.state.token}})
      }
    },
    connect_response(context, msg){
      // console.log('connected')
      context.commit('set_connection_name', msg['client_session'])
      if (this.getters.isLoggedIn){
        context.dispatch('getContragent')
        context.dispatch('getAccounts')
        context.dispatch('getRequests')
      }
    },
    auth_response(context, msg){
      if(msg.data !== undefined){
        context.dispatch('authUser', msg['data']['token'])
        context.dispatch('setUsername', msg['data']['username'])
        context.dispatch('setTopics', msg['data']['topics'])
        context.dispatch('localControl', msg['data']['local_control'])
        context.dispatch('getContragent')
        context.dispatch('getAccounts')
        context.commit('set_connection_name', msg['client_session'])
        // context.dispatch('getRequests')
      }
      else if(msg['error_msg']) {
        context.commit('login_error', msg['error_msg'])
      } else {
        context.dispatch('localControl', msg['data']['local_control'])
        context.commit('log_out')
      }
    },
    // Унифицировать
    signin_response(context, msg){
      context.dispatch('signinResult', msg)
    },
    check_pin_response(context, msg){
      context.dispatch('signinResult', msg)
    },
    signinconfirm_response(context, msg){
      context.dispatch('signinResultConfirm', msg)
    },
    api_response(context, msg){
      context.dispatch(msg['method'] + '_' + msg['event'].replace('api/', ''), msg)
    },

    get_contragent_response(context, msg){
      context.dispatch('setContragent', {data: msg['data'][0], partial: msg.partial || false})
    },
    get_accounts_response(context, msg){
      context.dispatch('setAccounts', {data: msg['data'], partial: msg.partial || false})
    },
    get_account_apps_response(context, msg){
      context.dispatch('setAccountApps', {data: msg['data'], partial: msg.partial || false})
    },
    get_app_com_params_response(context, msg){
      context.dispatch('setAppService', {data: msg['data'], partial: msg.partial || false})
    },
    get_balances_response(context, msg){
      context.dispatch('setBalances', {data: msg['data'], partial: msg.partial || false})
    },
    get_charges_response(context, msg){
      context.dispatch('setCharges', {data: msg['data'], partial: msg.partial || false})
    },
    get_payments_response(context, msg){
      context.dispatch('setPayments', {data: msg['data'], partial: msg.partial || false})
    },
    get_requests_response(context, msg){
      context.dispatch('setRequests', {data: msg['data'], partial: msg.partial || false})
    },
    get_sessions_response(context, msg){
      context.dispatch('setInternetTraffic', {data: msg['data'], partial: msg.partial || false})
    },
    get_phone_calls_response(context, msg){
      context.dispatch('setPhoneCalls', {data: msg['data'], partial: msg.partial || false})
    },
    get_current_receipt_response(context, msg){
      context.dispatch('setCurrentReceipt', {data: msg['data'], partial: msg.partial || false})
    },
    list_documents_response(context, msg){
      context.dispatch('setDocumentList', {data: msg['data'], partial: msg.partial || false})
    },
    get_document_response(context, msg){
      context.dispatch('setCurrentDocument', {data: msg['data'], partial: msg.partial || false})
    },
    get_document_content_response(context, msg){
      context.dispatch('setCurrentDocumentContent', {data: msg['data'], partial: msg.partial || false})
    },
    get_document_items_response(context, msg){
      context.dispatch('setCurrentDocumentItems', {data: msg['data'], partial: msg.partial || false})
    },
    get_app_tar_plan_change_list_response(context, msg){
      context.dispatch('setAppTarPlanChangeList', {data: msg['data'], partial: msg.partial || false})
    },
    get_app_block_tarif_list_response(context, msg){
      context.dispatch('setAppBlockTarifList', {data: msg['data'], partial: msg.partial || false})
    },
    control_users_list_response(context, msg){
      context.dispatch('setControlContragent', {data: msg['data'], partial: msg.partial || false})
    },
    control_response(context, msg){
      if (msg['method'] === 'server_clients') {
        context.dispatch('setControlClients', {data: msg['data'], partial: msg.partial || false})
      }
      else if (msg['method'] === 'new_users') {
        context.dispatch('setControlNewUsers', {data: msg['data'], partial: msg.partial || false})
      }
      else {
        context.dispatch('setControlUsers', {data: msg['data'], partial: msg.partial || false})
        let local_control = msg['data'] || false
        context.dispatch('localControl', local_control)
      }
    },
    passchange_response(context, msg){
      let success = msg['success'] || false
      let error_msg = msg['error_msg'] || null
      context.dispatch('setPassChanged', success)
      context.dispatch('setPassChangedError', error_msg)
    },
    ping(context, msg){
      let local_control = msg['local_control'] || false
      context.dispatch('localControl', local_control)
      context.dispatch('sendMessage', {'event':'pong'})
      if (!context.state.connection_name){
        context.dispatch('greet_request', null)
      }
    },
    contragent_response(context, msg){
      if(msg){msg = null}
    }
  }
})
